const textsConstants = Object.freeze({
  publishSuccess: `
  Thank you for your submission.
   We will review it within the next  24-48h. Upon approval, it will go live according to the schedule.`,
});

export default textsConstants;
